import { withInstall } from '@tw-element/utils'
import InputNumber from './src/input-number.vue'

export const TwInputNumber = withInstall(InputNumber)

export default TwInputNumber
export * from './src/input-number'
